export default {
    AllCareers({ state, commit, rootState })
    {
        commit('AllCareers')
    }
}